import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { Option, SVGFC } from '@repo/toolkit/types'
import { CadIcon, DollarTwoIcon, EuroIcon, GbpIcon } from '@repo/ui/icons'

export enum CurrencyEnum {
  USD = 'USD',
  CAD = 'CAD',
  EUR = 'EUR',
  GBP = 'GBP'
}

export const currencyEnumMapping: Record<
  CurrencyEnum,
  {
    label: string
    icon: SVGFC
    symbol: string
  }
> = {
  [CurrencyEnum.CAD]: {
    label: 'CAD',
    icon: () => <CadIcon color={tailwindColors.grey.DEFAULT} height="25" width="25" />,
    symbol: 'c$'
  },
  [CurrencyEnum.EUR]: {
    label: 'EUR',
    icon: () => <EuroIcon color={tailwindColors.grey.DEFAULT} height="25" width="25" />,
    symbol: '€'
  },
  [CurrencyEnum.GBP]: {
    label: 'GBP',
    icon: () => <GbpIcon color={tailwindColors.grey.DEFAULT} height="25" width="25" />,
    symbol: '£'
  },
  [CurrencyEnum.USD]: {
    label: 'USD',
    icon: () => <DollarTwoIcon color={tailwindColors.grey.DEFAULT} height="25" width="25" />,
    symbol: '$'
  }
}

export const currencyEnumOptions: Option<CurrencyEnum>[] = Object.values(CurrencyEnum).map(
  (c) => ({ label: currencyEnumMapping[c].label, value: c })
)
